module.exports = {"420106001":"积玉桥街道","420106002":"杨园街道","420106003":"徐家棚街道","420106005":"粮道街道","420106006":"中华路街道","420106007":"黄鹤楼街道","420106008":"紫阳街道","420106009":"白沙洲街道","420106010":"首义路街道","420106011":"中南路街道","420106012":"水果湖街道","420106013":"珞珈山街道","420106014":"石洞街道","420106015":"南湖街道","420106490":"东湖风景区街道（武昌）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420106.json
// module id = 1825
// module chunks = 0